<template>
  <footer :class="$style.root">
    <div>
      <core-text-component
        v-if="data?.richText"
        :string="data?.richText"
      />
    </div>

    <ul :class="$style.links">
      <li
        v-for="link in links"
        :key="link?.id"
      >
        <navigation-link-component
          :data="link"
        >
          <template #default="{ title, current }">
            {{ title }}
          </template>
        </navigation-link-component>
      </li>
    </ul>

    <ul
      v-if="data?.svgLogos?.length"
      :class="$style.logos"
    >
      <li
        v-for="logo in data?.svgLogos"
        :key="logo?.id"
      >
        <div
          v-html="logo?.svg"
          :class="$style.logo"
        />
      </li>
    </ul>

    <shared-newsletter-component
      :class="$style.newsletter"
      :includeLabel="false"
      v-if="!pageIsNewsletter"
    />
  </footer>
</template>

<script setup>
const route = useRoute()

const nuxtApp = useNuxtApp()
const { $i18n } = nuxtApp
const { locale } = $i18n

const { data, error } = await useAsyncData(() => {
  const slug = getAppVariant() === 'main' ? 'footer' : 'interim-footer'
  return $fetch('/api/strapi-rest', { query: { path: queryFooter(getPageQuery({slug: slug})) } })
}, { watch: [locale] } )

watch(data, () => {
  if (data?.value?.documentId) return
  data.value = getFirstObject(data.value?.data)
}, { immediate: true })

const pageIsNewsletter = computed(() => {
  return route?.name?.startsWith('newsletter')
})

const links = computed(() => {
  return data.value?.links?.filter((item) => {
    return getRoutePresence(getNavigationItem(item)?.link?.routeObject?.name)
  })
})
</script>

<style module lang="scss">
.root {
  composes: container font-size-small from global;

  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: var(--unit--horizontal);
  grid-row-gap: var(--font-small--line-height);

  padding-top: calc(var(--font-small--line-height) * 4);
  margin-bottom: calc(var(--unit--vertical) * 2);

  @media (max-width: $breakpoint-s) {
    grid-template-columns: 1fr;
  }
}

.newsletter {
  grid-column: 1 / -1;
}

.links {
  composes: reset-list from global;
  columns: 2;
  gap: var(--unit--horizontal);
}

.logos {
  composes: reset-list from global;

  grid-column: 1 / -1;

  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: calc(var(--unit--horizontal) * 2);
  align-items: center;

  margin-top: calc(var(--unit--vertical) * 1);
  margin-bottom: calc(var(--unit--vertical) * 1);
}

.logo  {
  width: 100%;
  height: auto;
}
</style>
